export default __webpack_public_path__ + "static/media/I_wdt_c_cap_0.bd6a3dda.mp3";